<!-- viewcontext is commented in 5.2.0 to improve the performance  -->
<div
  class="family-page product-search-result"
  [attr.data-testing-id]="'family-page-' + category().uniqueId"
  id="family-page-top"
>
  <div class="marketing-area">
    @if (category().categoryRef) {
    <ish-content-viewcontext
      viewContextId="viewcontext.include.family.base.top"
      [callParameters]="{ Category: category().categoryRef }"
    />
    }
  </div>

  <div class="row">
    <div class="col-md-3">
      <ish-skip-content-link skipToElementId="nav-breadcrumbs" linkText="common.skip_content.link.text.filter" />
      <custom-clear-all-filter />

      <custom-now-shopping-navigation />

      <div class="navigation-panel" [ngbCollapse]="isCollapsed">
        <!-- <ish-category-navigation [uniqueId]="category.categoryPath[0]"></ish-category-navigation> -->
        <br />
        <custom-filter-navigation [showCategoryFilter]="true" />
      </div>

      <a class="d-md-none mobile-filter-toggle btn btn-link btn-link-action" (click)="toggle()">
        {{ 'search.mobile.filter.trigger' | translate }}
        <fa-icon [icon]="['fas', isCollapsed ? 'angle-down' : 'angle-up']" />
      </a>

      <div class="marketing-area">
        @if (category().categoryRef) {
        <ish-content-viewcontext
          viewContextId="viewcontext.include.family.navigation"
          [callParameters]="{ Category: category().categoryRef }"
        />
        }
      </div>
    </div>
    <div class="col-md-9">
      <ish-breadcrumb />
      <h1>{{ category().name }}</h1>

      <div class="marketing-area">
        @if (category().categoryRef) {
        <ish-content-viewcontext
          viewContextId="viewcontext.include.family.content.top"
          [callParameters]="{ Category: category().categoryRef }"
        />
        }
      </div>

      <ish-product-listing
        [categoryId]="category().uniqueId"
        [productListingId]="{ type: 'category', value: category().uniqueId }"
        fragmentOnRouting="family-page-top"
        (productSortSelected)="deviceType() === 'mobile' ? (isCollapsed = true) : isCollapsed"
      />
      <!-- <ish-product-links></ish-product-links> -->
      <div class="marketing-area">
        @if (category().categoryRef) {
        <ish-content-viewcontext
          viewContextId="viewcontext.include.family.content.bottom"
          [callParameters]="{ Category: category().categoryRef }"
        />
        }
      </div>
    </div>
  </div>

  <div class="marketing-area">
    @if (category().categoryRef) {
    <ish-content-viewcontext
      viewContextId="viewcontext.include.family.base.bottom"
      [callParameters]="{ Category: category().categoryRef }"
    />
    }
  </div>
</div>
